import { useCookies } from "react-cookie"

const useLogoTransparency = () => {
    const cookieName = "LOGO_TRANSPARENCY"
    const [cookie, setCookie, removeCookie] = useCookies([cookieName])

    const createCookie = (transparency) => {
        setCookie(cookieName, transparency, {
            "path": "/",
        })
    }

    const deleteCookie = () => {
        removeCookie(cookieName, { "path": "/" })
    }

    const transparency = cookie[cookieName] ?? 50

    return [transparency, createCookie, deleteCookie]
}

export default useLogoTransparency